import { render, staticRenderFns } from "./goodsRegionSaleStat.vue?vue&type=template&id=08511fd8&"
import script from "./goodsRegionSaleStat.vue?vue&type=script&lang=js&"
export * from "./goodsRegionSaleStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports